import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard Analytics
import DashboardReducer from "./dashboard/reducer";

//Pages
import ProductsReducer from "./products/reducer";
import FilesReducer from "./importFiles/reducer";
import SuppliersReducer from "./suppliers/reducer";
import AnalysisReducer from "./analysis/reducer";
import SettingsReducer from "./settings/reducer";
import OrdersReducer from "./orders/reducer";
import UsersReducer from "./users/reducer";

// API Key
import APIKeyReducer from "./apiKey/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  APIKey: APIKeyReducer,
  Products: ProductsReducer,
  Files: FilesReducer,
  Suppliers: SuppliersReducer,
  Analysis: AnalysisReducer,
  Settings: SettingsReducer,
  Orders: OrdersReducer,
  Users: UsersReducer,
});

export default rootReducer;
